// Packages
import { useState, useEffect } from "react";
import { useNavigate /*, useParams*/ } from "react-router-dom";

// Elements
import { Container, Icon } from "./LangSelect.elements";
import { Dropdown, DropdownItem } from "./Dropdown.elements";

export default function LangSelect({ locale }) {
  const navigate = useNavigate();

  const [lang, setLang] = useState("EN");
  const [country, setCountry] = useState("GB");
  const [activeLang, setActiveLang] = useState({});
  const [langs, setLangs] = useState([]);

  const countries = {
    CA: [
      { lang: "EN", name: "English" },
      { lang: "FR", name: "Français" },
    ],
    HK: [
      { lang: "EN", name: "English" },
      { lang: "ZH", name: "中文" },
    ],
    BE: [
      { lang: "NL", name: "Nederlands" },
      { lang: "FR", name: "Français" },
    ],
    TH: [
      { lang: "EN", name: "English" },
      { lang: "TH", name: "แบบไทย" },
    ],
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const split = locale.toUpperCase().split("-");

    const lang = split[0];
    const country = split[1];

    setLang(lang);
    setCountry(country);
    country in countries ? setLangs(countries[country]) : setLangs(null);
    if (countries[country]) {
      const activeLang = countries[country].filter((l) => l.lang === lang);
      setActiveLang(activeLang[0]);
    }
  }, [locale]);

  function onChangeHandler(value) {
    const selectedLocale = `${value}-${country}`.toLowerCase();

    if (locale === selectedLocale) {
      return;
    }

    // Exception for ca-fr, which should use a custom URL
    if (country === "CA" && value === "FR") {
      navigate(`/fr-ca/avantages/avantagepourrestaurants`);
    } else {
      navigate(`/${selectedLocale}/benefits/diningbenefit`);
    }
  }

  return (
    <Container>
      {langs && (
        <Dropdown type="lang">
          <div
            className="dropdown"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <div className="selected-option">
              <Icon>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_476_3821)">
                    <path
                      d="M8.5 -0.000244141C12.9183 -0.000244141 16.5 3.58176 16.5 7.99976C16.5 12.4181 12.9183 15.9998 8.5 15.9998C4.08167 15.9998 0.5 12.4181 0.5 7.99976C0.5 3.58176 4.08167 -0.000244141 8.5 -0.000244141ZM8.95 10.9998V14.8848C10.1583 14.0848 11.1117 13.0118 11.7513 11.7758C10.9213 11.3551 10.0363 11.0965 9.13126 11.0139L8.95 10.9998ZM8.05 14.8844V11.0071C7.08267 11.0701 6.13467 11.3348 5.248 11.7841C5.86038 12.966 6.76144 13.9958 7.90013 14.7831L8.05 14.8844ZM12.544 12.2391C12.0497 13.1828 11.39 14.0398 10.586 14.7701C11.7083 14.4248 12.7117 13.8081 13.5197 12.9964C13.2083 12.7161 12.8827 12.4634 12.544 12.2391ZM4.45267 12.2421C4.11567 12.4658 3.79433 12.7224 3.48467 13.0011C4.28967 13.8081 5.28767 14.4221 6.404 14.7674C5.601 14.0391 4.94567 13.1834 4.45267 12.2421ZM15.5607 8.44976H13.574C13.5237 9.48176 13.3037 10.4814 12.928 11.4148C13.339 11.6781 13.733 11.9791 14.108 12.3158C14.9124 11.2716 15.4296 9.9996 15.5487 8.61055L15.5607 8.44976ZM3.42633 8.44976H1.43967C1.53067 9.90076 2.05633 11.2304 2.891 12.3141C3.26467 11.9788 3.65933 11.6804 4.069 11.4174C3.71993 10.5476 3.50589 9.61845 3.43852 8.6564L3.42633 8.44976ZM8.05 8.44976H4.343C4.38967 9.32242 4.57267 10.1658 4.87633 10.9574C5.81939 10.4853 6.82712 10.1965 7.85671 10.1113L8.05 10.0978V8.44976ZM12.6573 8.44976H8.95V10.0974C10.048 10.1608 11.1217 10.4528 12.1223 10.9541C12.4036 10.2227 12.5814 9.44815 12.6441 8.64982L12.6573 8.44976ZM14.1093 3.68609C13.7353 4.02142 13.341 4.31909 12.931 4.58242C13.2801 5.45198 13.4938 6.38106 13.5614 7.34311L13.5737 7.54976H15.5607C15.469 6.09942 14.944 4.76976 14.1093 3.68609ZM12.1237 5.04276C11.1806 5.51523 10.1735 5.80374 9.1434 5.88858L8.95 5.90209V7.54976H12.657C12.6103 6.67709 12.4273 5.83409 12.1237 5.04276ZM2.892 3.68442C2.08761 4.72827 1.57036 6.00024 1.4516 7.389L1.43967 7.54976H3.427C3.47833 6.52476 3.703 5.52609 4.08133 4.59142C3.66733 4.32642 3.26967 4.02342 2.892 3.68442ZM4.887 5.05009C4.603 5.78301 4.42125 6.55683 4.35721 7.35084L4.34367 7.54976H8.05V5.90209C6.95533 5.83942 5.885 5.54842 4.887 5.05009ZM8.05 4.99976V1.11442C6.855 1.90742 5.90067 2.98742 5.25767 4.22842C6.08517 4.64624 6.96745 4.90321 7.86937 4.98561L8.05 4.99976ZM8.95 1.11542V4.99942C9.91833 4.93642 10.8677 4.67042 11.7547 4.22076C11.1423 3.03689 10.2403 2.00518 9.10007 1.21686L8.95 1.11542ZM6.42067 1.22809C5.29567 1.57309 4.28967 2.19009 3.48033 3.00342C3.79433 3.28642 4.124 3.54109 4.466 3.76709C4.96267 2.81976 5.622 1.95809 6.42067 1.22809ZM10.596 1.23242C11.399 1.96109 12.055 2.81676 12.548 3.75842C12.885 3.53476 13.211 3.28409 13.521 3.00476C12.715 2.19476 11.715 1.57842 10.596 1.23242Z"
                      fill="#006FCF"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_476_3821">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </Icon>
              {activeLang.name}
            </div>
            {dropdownOpen && (
              <div className="dropdown-menu">
                {langs.map((l) => (
                  <DropdownItem
                    key={l.lang}
                    onClick={() => onChangeHandler(l.lang)}
                    active={l.lang === lang}
                  >
                    {l.name}
                  </DropdownItem>
                ))}
              </div>
            )}
          </div>
        </Dropdown>
      )}
    </Container>
  );
}
